import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { Customer } from '../models/customer.model';
import { CustomerStoreService } from '../services/customer-store.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerResolver implements Resolve<Customer> {
  constructor(private customerStoreService: CustomerStoreService, private authStoreService: AuthStoreService) {}

  public resolve(): Observable<Customer> {
    if (this.authStoreService.userInfo.customer_id) {
      return this.customerStoreService.loadCustomer(this.authStoreService.userInfo.customer_id);
    }
    return of(null);
  }
}
